import Account from "./index.jsx"

export default {
  "/account": Account,
  "/account/*": Account,
}
